import { Button, Flex, Modal } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SectionForm } from './components/SectionForm';
import { TitleContainer } from './ModalSection.styles';
import type { ModalSectionProps } from './types';
import { useModalSection } from './useModalSection';

const MODAL_WIDTH = 572;

export const ModalSection: React.FC<ModalSectionProps> = ({
  open,
  onClose,
  onSubmit,
  initialValues,
  mode,
  isLoading,
  hideDescription
}) => {
  const { form, isFormValid, handleClose, handleFinish, isEditMode } = useModalSection({
    open,
    onClose,
    onSubmit,
    initialValues,
    mode,
    isLoading
  });

  const { t } = useTranslation(['DefaultTranslations', 'ManagerBaseContentDetailTranslations']);

  const titleKey = useMemo(() => {
    if (isEditMode) {
      return hideDescription
        ? 'ManagerBaseContentDetailTranslations:EDIT_INTRODUCTION_SECTION'
        : 'ManagerBaseContentDetailTranslations:EDIT_SECTION';
    }

    return hideDescription
      ? 'ManagerBaseContentDetailTranslations:CREATE_INTRODUCTION_SECTION'
      : 'ManagerBaseContentDetailTranslations:CREATE_SECTION';
  }, [isEditMode, hideDescription]);

  const okTextKey = isEditMode ? 'DefaultTranslations:SAVE' : 'DefaultTranslations:CREATE';

  return (
    <Modal
      centered
      width={MODAL_WIDTH}
      open={open}
      onCancel={handleClose}
      maskClosable={false}
      wrapProps={{ onClick: (e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation() }}
      title={<TitleContainer>{t(titleKey)}</TitleContainer>}
      footer={
        <Flex gap={8} style={{ paddingTop: 16 }} justify="flex-end">
          <Button onClick={handleClose}>{t('DefaultTranslations:CANCEL')}</Button>
          <Button
            type="primary"
            disabled={isLoading || !isFormValid}
            onClick={form.submit}
            onSubmit={handleFinish}
            loading={isLoading}>
            {t(okTextKey)}
          </Button>
        </Flex>
      }>
      <SectionForm form={form} onFinish={handleFinish} hideDescription={hideDescription} />
    </Modal>
  );
};
